/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf, TransferState } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { INITIAL_STATE, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AppDynamicsModule } from '@fleetmatics/ui.insights';
import { FmCookieModule } from '@fleetmatics/ui.utilities';

import { environment } from '../../environments/environment';
import { APP_CONFIG } from './config/app-config.token';
import { CACHE_NONCE } from './config/cache-nonce.token';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { getInitialState, reducers } from './store/reducers/core.reducer';

@NgModule({
  imports: [
    AppDynamicsModule,
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictActionImmutability: true,
        strictActionSerializability: true
      }
    }),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument({ connectInZone: true }) : [],
    CommonModule,
    FmCookieModule.forRoot()
  ],
  providers: [
    { provide: INITIAL_STATE, useFactory: getInitialState, deps: [TransferState] },
    { provide: APP_CONFIG, useValue: environment.config },
    { provide: CACHE_NONCE, useValue: environment.config.cacheNonce }
  ],
  exports: []
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
